(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-subcollections"]) return;
  try {
    
  if (!customElements.get('collection-subnav')) {
    class CollectionSubnav extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-subcollection-scroller]');
        this.previousButton = this.querySelector('[data-subcollection-prev]');
        this.nextButton = this.querySelector('[data-subcollection-next]');

        if (!this.scroller || !this.previousButton || !this.nextButton) return;

        this.handleScroll = this.update.bind(this);
        this.handlePrevious = () => this.scroll(-1);
        this.handleNext = () => this.scroll(1);

        this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);

        this.resizeObserver = new ResizeObserver(this.handleScroll);
        this.resizeObserver.observe(this.scroller);

        requestAnimationFrame(this.handleScroll);
      }

      disconnectedCallback() {
        if (!this.scroller) return;

        this.scroller.removeEventListener('scroll', this.handleScroll);
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.resizeObserver?.disconnect();
      }

      scroll(direction) {
        const distance = Math.max(this.scroller.clientWidth * 0.8, 280);
        this.scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      update() {
        const maximumScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);
        const overflowing = maximumScroll > 2;

        this.toggleAttribute('data-overflowing', overflowing);
        this.previousButton.disabled = !overflowing || this.scroller.scrollLeft <= 2;
        this.nextButton.disabled = !overflowing || this.scroller.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define('collection-subnav', CollectionSubnav);
  }

  } catch(e) { console.error(e); }
})();
})();
